export default __webpack_public_path__ + "static/media/fishery.73fbaa8d.svg";